<template>
	<v-card class="pa-0" v-if="main_element">
		<v-card-text class="pa-0" style="overflow:hidden">
			<div class="d-flex align-center justify-space-between pa-2" v-if="showHeader">
				<p class="font-weight-bold body-2 mb-0 mr-2">Documentos y Planos Normativos</p>
			</div>
			<div class="d-flex flex-column align-center my-3 mx-4" style="gap: 10px;" v-if="!userInfo.user_id">
				<div>
					<p class="caption mb-0 font-weight-bold">Este CRM / Solicitud no tiene un usuario asociado.</p>
					<p class="caption mb-0">Antes de crear un Presupuesto Desarchivo debes asociar este CRM / Solicitud a un usuario del sistema.</p>
					<p class="caption mb-0">Esto es con el objetivo de que al pagar el desarchivo el cliente pueda ser identificado correctamente.</p>
				</div>
				<UserAccountSelector :item="crm" :large="true"/>
			</div>
			<div class="d-flex justify-space-between align-start my-3 mx-4" v-else>
				<div v-if="elementReports.length">
					<v-select
						v-model="selectedReport"
						:items="elementReports"
						:menu-props="{ bottom: true, offsetY: true }"
						label="Presupuesto Desarchivo"
						item-text="value"
						item-value="id"
						class="custom-height-search custom-height-calendar custom-select-uf mb-0 mr-1 w-100"
						outlined
						dense
						required
						hide-details
						return-object
						style="max-width: 300px;"
					>
						<template v-slot:item="data">
							<v-list-item-content>
								<v-list-item-title>
									<div class="d-flex justify-space-between align-center" style="width: 300px">
										<p class="mb-0 mr-2 caption">{{ data.item.serial?.serial }} - LP{{ main_element.project_line_info?.project_line?.number }} - {{ data.item.prefix?.prefix }} {{ data.item.report_index }}</p>
										<v-chip x-small color="gray">
											{{reportAssociationType(data.item)}}
										</v-chip>
									</div>
								</v-list-item-title>
							</v-list-item-content>
						</template>
						<template v-slot:selection="data">
							<div class="d-flex justify-space-between align-center" style="width: 300px">
								<p class="mb-0 mr-2 caption">{{ data.item.serial?.serial }} - LP{{ main_element.project_line_info?.project_line?.number }} - {{ data.item.prefix?.prefix }} {{ data.item.report_index }}</p>
								<v-chip x-small color="gray">
									{{reportAssociationType(data.item)}}
								</v-chip>
							</div>
						</template>
					</v-select>
					<div class="d-flex align-center">
						<div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										color="#524D4D"
										v-bind="attrs"
										v-on="on"
										@click="changeLockedUnarchiveStatus"
									>
										<v-icon size="20">{{lockedUnarchive ? 'mdi-lock-outline':'mdi-lock-open-outline'}}</v-icon>
									</v-btn>
								</template>
								<span>{{lockedUnarchive ? 'Desbloquear Desarchivo Completo':'Bloquear Desarchivo Completo'}}</span>
							</v-tooltip>
						</div>
						<div>
							<v-menu offset-y>
								<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												depressed
												color="#524D4D"
												dark
												icon
												v-bind="{ ...tooltipAttrs, ...menuAttrs }"
												v-on="{ ...tooltipOn, ...menuOn }"
											>
												<v-icon size="20">mdi-briefcase-clock-outline</v-icon>
											</v-btn>
										</template>
										<span>Historial del Desarchivo {{ selectedReport?.serial?.serial }} - LP{{ main_element.project_line_info?.project_line?.number }} - {{ selectedReport?.prefix?.prefix }} {{ selectedReport?.report_index }}</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0 white">
									<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
										<div>
											<p class="caption mb-0 font-weight-bold white--text">Historial del Desarchivo [{{ selectedReport?.serial?.serial }} - LP{{ main_element.project_line_info?.project_line?.number }} - {{ selectedReport?.prefix?.prefix }} {{ selectedReport?.report_index }}]</p>
										</div>
									</v-list-item>
									<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
										<div class="d-flex justify-space-between align-center flex-grow-1">
											<p class="caption mb-0 text--disabled">Estado</p>
											<p class="caption mb-0 text--disabled" style="width: 90px;">Fecha</p>
										</div>
									</v-list-item>
									<v-divider></v-divider>
									<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
										<v-list-item
											v-for="(budgetStatus, index) in selectedReport?.statuses || []"
											:key="'ctstatus-'+index"
											dense
											style="min-width: 350px;"
											class="white"
										>
											<v-list-item-title dense>
												<div class="d-flex justify-space-between align-center item-background-hover">
													<div class="d-flex align-center justify-space-between caption mr-6">
														<v-icon class="mr-1" x-small :color="reportStatusColor(budgetStatus.status)">mdi-circle</v-icon>
														<b>{{budgetStatus.status | budgetStatus}}</b>
													</div>
													<div class="d-flex justify-end caption" style="width: 90px;">
														<p class="mb-0 caption text-end">{{budgetStatus.created_at | toDateTime}}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>

						<v-menu offset-y>
							<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
								<v-tooltip bottom>
									<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
										<v-btn
											icon
											dark
											color="#524D4D"
											class="mr-2"
											v-bind="{ ...tooltipAttrs, ...menuAttrs }"
											v-on="{ ...tooltipOn, ...menuOn }"
										>
											<v-icon size="20">mdi-file-clock-outline</v-icon>
										</v-btn>
									</template>
									<span>Historial de PDF enviados al cliente - {{ selectedReport?.serial?.serial }} - LP{{ main_element.project_line_info?.project_line?.number }} - {{ selectedReport?.prefix?.prefix }} {{ selectedReport?.report_index }}</span>
								</v-tooltip>
							</template>
							<v-list dense class="py-0 white">
								<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
									<div>
										<p class="caption mb-0 font-weight-bold white--text">Historial del PDF Desarchivo [{{ selectedReport?.serial?.serial }} - LP{{ main_element.project_line_info?.project_line?.number }} - {{ selectedReport?.prefix?.prefix }} {{ selectedReport?.report_index }}]</p>
									</div>
								</v-list-item>
								<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
									<div class="d-flex align-center flex-grow-1">
										<p class="caption mb-0 text--disabled" style="width: 100px;">Estado</p>
										<p class="caption mb-0 text--disabled" style="width: 120px;">Fecha</p>
										<p class="caption mb-0 text--disabled" style="width: 70px;">Acción</p>
									</div>
								</v-list-item>
								<v-divider></v-divider>
								<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
									<v-list-item
										v-for="(reportPdf, index) in selectedReport?.pdf_history || []"
										:key="'bpdfhistory-'+index"
										dense
										style="min-width: 320px;"
										class="white"
										@click="$store.commit('reports/setReportPdfModal', {...selectedReport, ...{forced_pdf: reportPdf}})"
									>
										<v-list-item-title dense>
											<div class="d-flex align-center item-background-hover">
												<div class="d-flex align-center caption"  style="width: 100px;">
													<v-icon class="mr-1" x-small :color="reportStatusColor(reportPdf?.report_status?.status)">mdi-circle</v-icon>
													<b>{{reportPdf.report_status?.status | budgetStatus}}</b>
												</div>
												<div class="d-flex align-center caption" style="width: 120px;">
													<p class="mb-0 caption text-end">{{reportPdf.created_at | toDateTime}}</p>
												</div>
												<div class="d-flex align-center caption" style="width: 70px;">
													<v-btn
														text
														x-small
														@click="$store.commit('reports/setReportPdfModal', {...selectedReport, ...{forced_pdf: reportPdf}})"
													>
														<p class="mb-0 caption">Ver PDF</p>
													</v-btn>
												</div>
											</div>
										</v-list-item-title>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</v-menu>

						<v-chip
							:color="selectedReport?.last_status?.status | budgetStatusColor"
							label
							outlined
							x-small
							class="px-1"
						>
							<b>{{ selectedReport?.last_status?.status | budgetStatus }}</b>
						</v-chip>
					</div>
				</div>
				<div class="px-2 text-center" v-else>
					<p class="caption">No hay presupuesto de desarchivo creados</p>
				</div>
				<div class="d-flex flex-column align-end justify-center" v-if="crm && (hasAssociationTypes.includes('preproject') || hasAssociationTypes.includes('project'))">
					<v-alert
						dense
						colored-border
						border="left"
						color="warning"
						max-width="400px"
					>
						<p class="mb-0 caption">No se puede generar un presupuesto de desarchivo de CRM ya que este proyecto está en una etapa más avanzada</p>
					</v-alert>
				</div>
				<div v-else>
					<!-- <div class="d-flex flex-column align-end justify-center" v-if="pendingReportBudget">
						<v-btn
							outlined
							color="#524D4D"
							small
							@click="handleGoToPendingBudget"
						>
							<v-icon small>mdi-file-document-outline</v-icon>
							<p class="mb-0 ml-2 caption">Ir a Presupuesto Desarchivo</p>
						</v-btn>
						<p class="mb-1 text-right" style="font-size: 10px;">Ya existe un presupuesto desarchivo en preparación</p>
					</div> -->
					<div class="d-flex flex-column align-end justify-center" v-if="requestingDocuments">
						<div class="d-flex flex-column align-end">
							<v-select
								v-model="unarchiveValue"
								:items="unarchiveValues"
								:menu-props="{ bottom: true, offsetY: true }"
								:label="unarchiveValue ? unarchiveValue.name:'Valor Desarchivo'"
								item-text="value"
								item-value="value"
								class="custom-height-search custom-height-calendar custom-select-uf mb-1 mr-1 w-100"
								outlined
								dense
								required
								hide-details
								return-object
								style="max-width: 180px;"
							>
								<template v-slot:item="data">
									<v-list-item-content>
										<v-list-item-title>
											<div style="width: 180px">
												<p class="mb-0 caption">{{data.item.name}}</p>
												<p class="mb-0 font-weight-bold">${{data.item.value | toThousandFilter}}</p>
											</div>
										</v-list-item-title>
									</v-list-item-content>
								</template>
								<template v-slot:selection="data">
									<div style="width: 180px">
										<p class="mb-0 font-weight-bold caption">${{data.item.value | toThousandFilter}}</p>
									</div>
								</template>
							</v-select>

							<!-- <v-text-field
								v-model="unarchiveValue"
								type="number"
								step="1"
								label="Valor Desarchivo (CLP)"
								outlined
								required
								dense
								hide-details
								class="custom-height-search custom-height-calendar mr-2"
								style="font-size: 14px;max-width: 180px;"
								@keydown.enter.prevent
								@keypress="validateCLP"
								@input="sanitizeIntegerInput"
							></v-text-field> -->

							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										outlined
										color="#524D4D"
										small
										:disabled="!unarchiveValue"
										v-bind="attrs"
										v-on="on"
										@click="createReportUnarchive"
									>
										<v-icon small>mdi-file-document-outline</v-icon>
										<p class="mb-0 ml-2 caption" v-if="pendingReportBudget">Ir al Presupuesto Desarchivo</p>
										<p class="mb-0 ml-2 caption" v-else>Nuevo Presupuesto Desarchivo</p>
									</v-btn>
								</template>
								<span>Preparar Presupuesto Desarchivo</span>
							</v-tooltip>
						</div>
						<p class="mb-1 text-right" style="font-size: 10px;">Selecciona un valor para el desarchivo</p>
					</div>
					<div v-else>
						<p class="text-right caption">Selecciona al menos un documento "A Solicitar"</p>
					</div>
				</div>
			</div>
			<v-card class="pa-0" :disabled="lockedUnarchive">
				<v-simple-table class="custom-table rounded" disabled>
					<thead>
						<tr>
							<th></th>
							<th class="text-center"></th>
							<th class="text-center">DOCUMENTO/PLANO</th>
							<th class="text-center">EXISTENTE</th>
							<th class="text-center">A SOLICITAR</th>
							<th class="text-center">FECHA SOLICITUD</th>
							<th class="text-center">FECHA MÁXIMA DE ENTREGA</th>
							<th class="text-center">FECHA DE ENTREGA</th>
							<th class="text-center">ESTADO</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="(category, cIndex) in documentTypes">
							<tr
								v-for="(un, uIndex) in category.documents"
								:key="`cat-${cIndex}-un-${uIndex}`"
								:class="[getCustomClass(un), { loading: un.loading }]"
							>
								<td
									v-if="uIndex === 0"
									:rowspan="category.documents.length"
								>
									{{ category.name }}
								</td>
								<td>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												:color="lockedUnarchives[un.id] || payedDocuments.includes(un.id) ? 'error lighten-2':'success'"
												v-bind="attrs"
												v-on="on"
												v-show="deliveredStatusMap[un.id] || payedDocuments.includes(un.id)"
												@click="unblockUnarchive(un)"
											>
												<v-icon size="20">{{getLockIcon(un)}}</v-icon>
											</v-btn>
										</template>
										<span>{{ getLockText(un) }}</span>
									</v-tooltip>
								</td>
								<td>{{un.text ? un.text + ' / ' + un.label:un.label}}</td>
								<td>
									<div class="d-flex justify-center">
										<v-checkbox
											:input-value="main_element.documents.find(doc => doc.document_type_id === un.id)?.existent"
											dense
											hide-details
											color="black"
											class="caption my-0 py-0 custom-checkbox"
											:disabled="lockedUnarchives[un.id] || payedDocuments.includes(un.id)"
											@change="val => handleDocumentChange({ existent: val }, un)"></v-checkbox>
									</div>
								</td>
								<td>
									<div class="d-flex justify-center">
										<v-checkbox
											:input-value="main_element.documents.find(doc => doc.document_type_id === un.id)?.required"
											dense
											hide-details
											color="black"
											class="caption my-0 py-0 custom-checkbox"
											:disabled="lockedUnarchives[un.id] || payedDocuments.includes(un.id)"
											@change="val => handleDocumentChange({ required: val }, un)"></v-checkbox>
									</div>
								</td>
								<td>
									<div v-if="main_element.documents.find(doc => doc.document_type_id === un.id)?.existent || !main_element.documents.find(doc => doc.document_type_id === un.id)?.required">--</div>
									<DocumentDateSelector :documentTypeId="un.id" :dateType="1" :loading="status => { un.loading = status }" :delivered="lockedUnarchives[un.id]" v-else/>
								</td>
								<td>
									<div v-if="main_element.documents.find(doc => doc.document_type_id === un.id)?.existent || !main_element.documents.find(doc => doc.document_type_id === un.id)?.required">--</div>
									<DocumentDateSelector :documentTypeId="un.id" :dateType="2" :loading="status => { un.loading = status }" :delivered="lockedUnarchives[un.id]" v-else/>
								</td>
								<td>
									<div v-if="main_element.documents.find(doc => doc.document_type_id === un.id)?.existent || !main_element.documents.find(doc => doc.document_type_id === un.id)?.required">--</div>
									<DocumentDateSelector :documentTypeId="un.id" :dateType="3" :loading="status => { un.loading = status }" :delivered="lockedUnarchives[un.id]" v-else/>
								</td>
								<td>
									<v-icon v-if="status(un.id)" :color="status(un.id).color" small>{{ status(un.id).icon }}</v-icon>
									<p class="mb-0" v-if="status(un.id)">{{status(un.id).label}}</p>
								</td>
							</tr>
						</template>
					</tbody>
				</v-simple-table>
			</v-card>
		</v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import DocumentDateSelector from '@/components/Views/PreProjects/DocumentDateSelector'
import UserAccountSelector from '@/components/Views/CRM/Sections/UserAccountSelector'
import {updateDocumentRevision} from '@/helpers/api/preprojects'
import {createReport} from '@/helpers/api/reports'
import { updateProjectLineInfo } from '@/helpers/api/projectlines'
import budgetStatuses from '@/components/Helpers/Constants/budget.js'

export default {
  name: 'DocumentTable',
	components: {DocumentDateSelector, UserAccountSelector},
	props: {
		showHeader: { type: Boolean, default: true }
	},
	computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		unarchive(){
			return [
				{ id: 1, text: 'CIP', label: 'Certificado de Informes Previos' },
				{ id: 2, text: 'CVS', label: 'Certificado de Vivienda Social' },
				{ id: 3, text: 'CE', label: 'Certificado Expropiación' },
				{ id: 4, text: 'CN', label: 'Certificado de Número' },
				{ id: 5, text: 'CUS', label: 'Certificado Uso de Suelo' },
				{ id: 6, text: 'PE', label: 'Permiso de Edificación' },
				{ id: 7, text: 'RD', label: 'Recepción Definitiva' },
				{ id: 8, text: 'RC', label: 'Resolución Copropiedad' },
				{ id: 9, text: 'CPA', label: 'Copia Plano Arquitectura' },
				{ id: 10, text: 'CPL', label: 'Copia Plano Estructura' },
				{ id: 11, text: 'CPC', label: 'Copia Plano Copropiedad' },
				{ id: 12, text: 'CPLO', label: 'Copia Plano Loteo' },
				{ id: 13, text: 'CPSP', label: 'Copia Plano Subdivisión Predial' },
				{ id: 14, text: 'PT', label: 'Copia Plano Terreno' },
				{ id: 15, text: 'CPSP', label: 'Copia Plano Subdivisión Predial' },
				{ id: 16, text: 'CDV', label: 'Certificado Dominio Vigente' },
				{ id: 17, text: 'CAFD', label: 'Certificado Avalúo Fiscal Detallado' },
				{ id: 18, text: 'PA', label: 'Planos Agua Potable y Alcantarillado' },
				{ id: 19, text: 'CTPE', label: 'Copia TE1 y Planos Eléctricos' },
				{ id: 20, text: 'CTOPG', label: 'Copia TC6 u Otros y Planos de Gas' }
			]
		},
		userInfo(){
			if(this.crm?.user){
				const user = this.crm.user
				if(user && user.user && user.user.profile){
					return {
						name: user.user.profile.name,
						lastname: user.user.profile.lastname,
						second_lastname: user.user.profile.second_lastname,
						email: user.user.email,
						phone: user.user.profile.phone,
						user_id: user.user_id,
						account: true
					}
				}
				return {
					name: user.name,
					lastname: user.lastname,
					second_lastname: user.second_lastname,
					email: user.email,
					phone: user.phone,
					user_id: user.user_id,
				}
			}
			if(this.preproject?.client){
				return {
					name: this.preproject.client.profile?.name,
					lastname: this.preproject.client.profile?.lastname,
					second_lastname: this.preproject.client.profile?.second_lastname,
					email: this.preproject.client.email,
					phone: this.preproject.client.profile?.phone,
					user_id: this.preproject.client.id,
					account: true
				}
			}
			return null
		},
		requestingDocuments(){
			return this.main_element.documents.some(doc => doc.required)
		},
		deliveredStatusMap() {
			const map = {};
			for (let i = 1; i <= 20; i++) {
				const s = this.status(i);
				map[i] = s?.delivered ?? false;
			}
			return map;
		},
		elementReports(){
			return this.main_element.report_budgets.filter(report => report.budget)
		},
		pendingReportBudget(){
			return this.elementReports.find((rep) => {
				return rep.last_status?.status != budgetStatuses.PAGADO
			})
		},
		payedReportsBudget(){
			return this.elementReports.filter((rep) => {
				return rep.last_status?.status == budgetStatuses.PAGADO
			})
		},
		payedDocuments(){
			return this.payedReportsBudget.flatMap(
				item => item.budget?.included_documents || []
			)
		},
		unarchiveValues(){
			return this.$store.state.companies.companyUnarchiveValues
		},
		hasAssociationTypes(){
			const mainTypes = {
				"App\\Models\\BotConversation": "crm",
				"App\\Models\\PreProject": "preproject",
				"App\\Models\\Project": "project",
			}
			if(this.main_element.associations?.associations?.length){
				return this.main_element.associations?.associations.map(a => mainTypes[a.morphable_type])
			}
			return [] 
		},
		preproject(){
			return this.$store.state.preprojects.preProject
		},
		crm(){
			return this.$store.state.crm.conversation
		},
    main_element() {
      return this.preproject || this.crm
    },
	},
	watch: {
		elementReports(newValue){
			if(newValue && newValue.length){
				const found = newValue.find(el => el.morphable_type == 'App\\Models\\PreProject')
				if(found){
					this.selectedReport = found
				}
				else{
					this.selectedReport = newValue[0]
				}
			}
		},
		selectedReport(newValue){
			if(newValue){
				this.unarchiveValue = {
					value: newValue.budget?.total_clp
				}
			}
		}
	},
	data(){
		return{
			budgetStatuses,
			selectedReport: null,
			lockedUnarchive: false,
			unarchiveValue: null,
			debouncers: {},
			pendingUpdates: {},
			lockedUnarchives: {},
			documentTypes: [
				{
					name: 'DESARCHIVO MUNICIPAL',
					documents: [
						{ id: 1, loading: false, text: 'CIP', label: 'Certificado de Informes Previos', category: 1 },
						{ id: 2, loading: false, text: 'CVS', label: 'Certificado de Vivienda Social', category: 1 },
						{ id: 3, loading: false, text: 'CE', label: 'Certificado Expropiación', category: 1 },
						{ id: 4, loading: false, text: 'CN', label: 'Certificado de Número', category: 1 },
						{ id: 5, loading: false, text: 'CUS', label: 'Certificado Uso de Suelo', category: 1 },
						{ id: 6, loading: false, text: 'PE', label: 'Permiso de Edificación', category: 1 },
						{ id: 7, loading: false, text: 'RD', label: 'Recepción Definitiva', category: 1 },
						{ id: 8, loading: false, text: 'RC', label: 'Resolución Copropiedad', category: 1 },
						{ id: 9, loading: false, text: 'CPA', label: 'Copia Plano Arquitectura', category: 1 },
						{ id: 10, loading: false, text: 'CPL', label: 'Copia Plano Estructura', category: 1 },
						{ id: 11, loading: false, text: 'CPC', label: 'Copia Plano Copropiedad', category: 1 },
						{ id: 12, loading: false, text: 'CPLO', label: 'Copia Plano Loteo', category: 1 },
						{ id: 13, loading: false, text: 'CPSP', label: 'Copia Plano Subdivisión Predial', category: 1 },
					]
				},
				{
					name: 'CBR',
					documents: [
						{ id: 14, loading: false, text: 'PT', label: 'Copia Plano Terreno', category: 2 },
						{ id: 15, loading: false, text: 'CPSP', label: 'Copia Plano Subdivisión Predial', category: 2 },
						{ id: 16, loading: false, text: 'CDV', label: 'Certificado Dominio Vigente', category: 2 },
					]
				},
				{
					name: 'SII',
					documents: [
						{ id: 17, loading: false, text: 'CAFD', label: 'Certificado Avalúo Fiscal Detallado', category: 3 },
					]
				},
				{
					name: 'SANITARIO',
					documents: [
						{ id: 18, loading: false, text: 'PA', label: 'Planos Agua Potable y Alcantarillado', category: 4 },
					]
				},
				{
					name: 'SEC',
					documents: [
						{ id: 19, loading: false, text: 'CTPE', label: 'Copia TE1 y Planos Eléctricos', category: 5 },
						{ id: 20, loading: false, text: 'CTOPG', label: 'Copia TC6 u Otros y Planos de Gas', category: 5 },
					]
				}
			],
			cbr: [
				{ id: 14, loading: false, text: 'PT', label: 'Copia Plano Terreno' },
				{ id: 15, loading: false, text: 'CPSP', label: 'Copia Plano Subdivisión Predial' },
				{ id: 16, loading: false, text: 'CDV', label: 'Certificado Dominio Vigente' }
			],
			sii: [
				{ id: 17, loading: false, text: 'CAFD', label: 'Certificado Avalúo Fiscal Detallado' }
			],
			instalations: [
				{ id: 18, loading: false, text: 'PA', label: 'Planos Agua Potable y Alcantarillado' }
			],
			sec: [
				{ id: 19, loading: false, text: 'CTPE', label: 'Copia TE1 y Planos Eléctricos' },
				{ id: 20, loading: false, text: 'CTOPG', label: 'Copia TC6 u Otros y Planos de Gas' }
			]
		}
	},
	mounted(){
		const data = {
			start: 0,
			limit: 1000
		}
		this.$store.dispatch('companies/getCompanyUnarchiveValues', data)
		if(this.elementReports && this.elementReports.length){
			const found = this.elementReports.find(el => el.morphable_type == 'App\\Models\\PreProject')
			if(found){
				this.selectedReport = found
			}
			else{
				this.selectedReport = this.elementReports[0]
			}
		}
		if(this.main_element.documents && this.main_element.documents.length){
			this.main_element.documents.forEach(doc => {
				this.$set(
					this.lockedUnarchives,
					doc.document_type_id,
					!!this.status(doc.document_type_id)?.delivered
				)
			})
		}
		if(this.main_element.project_line_info){
			this.lockedUnarchive = !this.main_element.project_line_info.open_document_revision
		}
	},
	methods: {
		handleGoToPendingBudget(){
			const docs = this.main_element.documents
				.map(d => this.unarchive.find(u => u.id === d.document_type_id && d.required && !d.existent))
				.filter(Boolean)
				.filter(d => !this.payedDocuments.includes(d.id))
			
			const included_documents = docs.map(d => d.id)
			const areEqual = included_documents.length === this.pendingReportBudget.budget?.included_documents?.length && included_documents.every(v => this.pendingReportBudget.budget?.included_documents?.includes(v))
			if(areEqual){
				this.$router.push({ name: 'ReportBudgetDetail', query: { id: this.pendingReportBudget.id } })
			}
			else{
				this.createReportUnarchive()
			}
		},
		unblockUnarchive(un){
			if(this.payedDocuments.includes(un.id)){
				const notResponsibleMessage = {
					title: 'Acción no disponible',
					message: 'El documento ha sido incluido en un desarchivo que ya ha sido pagado. No se puede retirar.',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', notResponsibleMessage)
				return
			}
			this.$set(this.lockedUnarchives, un.id, !this.lockedUnarchives[un.id])
		},
		getLockText(un){
			if(this.payedDocuments.includes(un.id)){
				return 'Documento Bloqueado, el desarchivo ya se ha pagado'
			}
			else if(this.lockedUnarchives[un.id]){
				return 'Desbloquear Desarchivo'
			}
			return 'Bloquear Desarchivo'
		},
		getLockIcon(un){
			if(this.payedDocuments.includes(un.id)){
				return 'mdi-lock'
			}
			else if(this.lockedUnarchives[un.id]){
				return 'mdi-lock-outline'
			}
			return 'mdi-lock-open-outline'
		},
		reportAssociationType(report){
			const mainTypes = {
				"App\\Models\\BotConversation": "CRM",
				"App\\Models\\PreProject": "PreProyecto",
				"App\\Models\\Project": "Proyecto",
			}
			return mainTypes[report.morphable_type]
		},
		isDelivered(un) {
			const delivered = this.status(un.id)?.delivered || false
			const unlocked = this.lockedUnarchives[un.id] === false

			if (delivered && unlocked) {
				return false
			}
			return delivered
		},
		reportStatusColor(contractStatus){
			return this.$options.filters.budgetStatusColor(contractStatus)
		},
		getCustomClass(un){
			if(this.main_element.documents.find(doc => doc.document_type_id === un.id)?.existent) {
				return 'green lighten-5'
			}
			else if(
				this.main_element.documents.find(doc => doc.document_type_id === un.id)?.required &&
				!this.main_element.documents.find(doc => doc.document_type_id === un.id)?.delivered_date
			) {
				return 'orange lighten-5'
			}
			return ''
		},
		debounceGetPreProject: _debounce(function(){ this.getPreProject() }, 1000),
		getPreProject(){
			this.$store.dispatch('preprojects/getPreProject', { 
				preproject_id: this.preproject?.id,
				showLoader: false 
			})
		},
		debounceGetCrm: _debounce(function(){ this.getCrm() }, 1000),
		getCrm(){
			this.$store.dispatch('crm/getConversation', {
				conversation_id: this.crm?.id,
				showLoader: false 
			})
		},
		getDebouncer(documentTypeId) {
			if (!this.debouncers[documentTypeId]) {
				this.debouncers[documentTypeId] = _debounce(
					(id) => {
						const data = {
							...this.pendingUpdates[id],
							document_type_id: id,
							preproject_id: this.preproject?.id,
							crm_id: this.crm?.id,
						}
						delete this.pendingUpdates[id]

						updateDocumentRevision(data)
						// if(this.preproject) this.debounceGetPreProject()
						// if(this.crm)  this.debounceGetCrm()
					},
					2000
				)
			}
			return this.debouncers[documentTypeId]
		},
		handleDocumentChange(changes, documentType) {
			const idx = this.main_element.documents.findIndex(
				doc => doc.document_type_id === documentType.id
			)

			let currentDoc = idx !== -1 ? this.main_element.documents[idx] : {}

			if (changes.existent === true && currentDoc.required === true) {
				changes.required = false
			}
			if (changes.required === true && currentDoc.existent === true) {
				changes.existent = false
			}

			if (idx !== -1) {
				this.$set(this.main_element.documents, idx, {
					...this.main_element.documents[idx],
					...changes,
				})
			} else {
				this.$set(this.main_element.documents, this.main_element.documents.length, {
						document_type_id: documentType.id,
						preproject_id: this.preproject?.id,
						crm_id: this.crm?.id,
						...changes,
				})
			}

			this.pendingUpdates[documentType.id] = {
				...(this.pendingUpdates[documentType.id] || {}),
				...changes
			}

			this.getDebouncer(documentType.id)(documentType.id)
		},
		status(documentTypeId){
			const base = [
				{ icon: 'mdi-check-circle-outline', label: 'Entregado', color: 'green', delivered: true },
				{ icon: 'mdi-timer-sand', label: 'En Espera', color: 'orange', delivered: false },
				{ icon: 'mdi-progress-alert', label: 'Atrasado', color: 'red', delivered: false },
				{ icon: 'mdi-text-box-check-outline', label: 'Existente', color: 'green', delivered: true },
			]
			const found = this.main_element.documents.find((document) => {
				return document.document_type_id == documentTypeId
			})

			if (found) {
				if (found.existent) {
					return base[3];
				}
				if (!found.request_date) {
					return null;
				}
				if (found.delivered_date) {
					return base[0];
				}
				if (!found.max_date || ( found.max_date && moment().isBefore(found.max_date) ) ) {
					return base[1];
				}
				if (found.max_date && moment().isAfter(found.max_date)) {
					return base[2];
				}
			}
			return null;
		},
		async createReportUnarchive(){
			const report_value = this.unarchiveValue?.value || this.pendingReportBudget?.budget?.total_clp
			const formatedUnarchiveValue = this.$options.filters.toThousandFilter(report_value)

			const docs = this.main_element.documents
				.map(d => this.unarchive.find(u => u.id === d.document_type_id && d.required && !d.existent))
				.filter(Boolean)
				.filter(d => !this.payedDocuments.includes(d.id))

			// const default_tax = this.selectedCompany?.company?.default_tax
			const html = `
				<div id="fixedcontent" contenteditable="false">
					<p><strong>Gestión de documentos (desarchivo)</strong></p><br/>
					<p><strong>Total:</strong> $${formatedUnarchiveValue} {tax_name} (Se realiza un solo pago al inicio por el 100%).</p><br/>

					<p><strong>Listado de Documentos a Solicitar:</strong></p>
					<ul>
						{docs_included_listing}
					</ul>
					<br/>
					<p><strong>Notas:</strong></p>
					<ul>
						<li>Existan o no documentos el costo de desarchivo es el mismo (no hay reembolso). Las copias de planos y documentos corresponden a lo aprobado y que sirva para el proyecto.</li>
						<li>Los plazos de entrega de los planos de agua potable y alcantarillado por Aguas Andinas, son de 20 días hábiles como mínimo.</li>
						<li>El propietario debe entregar una copia del Certificado de avalúo fiscal detallado y una copia de boleta de servicios de agua potable y alcantarillado.</li>
						<li>Una vez recopilada la información, se deberá realizar una visita técnica con un costo de $60.000 + IVA con el fin de revisar la propiedad en concordancia con la información municipal entregada.</li>
					</ul>
				</div>
			`

			const included_documents = docs.map(d => d.id)
			let data = {
				is_unarchive: true,
				title: 'Presupuesto Desarchivo',
				item_type: 'preproject',
				item_id: this.main_element?.id,
				report_html: [html],
				prefix_id: 5,
				budget_type: [1],
				budget_value_clp: report_value,
				included_documents
			}
			if(this.crm){
				data.item_type = 'crm'
			}
			if(!this.main_element.responsible_id){
				const notResponsibleMessage = {
					title: 'Selecciona Responsable',
					message: 'Por favor, primero selecciona un responsable del proyecto.',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', notResponsibleMessage)
				return null
			}
			const report = await createReport(data)
			if(report.code == 200){
				if(report.has_opened_report){
					const dataInfo = {
						...report.report,
						doc_type: 4,
					};
					this.$store.commit('general/setExistentDocumentNotificationModalData', dataInfo);
					this.$store.commit('general/setExistentDocumentNotificationModal', true);
				}
				else{
					this.$router.push({ name: 'ReportBudgetDetail', query: { id: report.report.id } })
				}
			}
		},
		validateCLP(e) {
			if (e.key === 'e') {
				e.preventDefault()
			}
			if(e.target?.value > 9999999999){
				e.preventDefault();
			}
		},
		sanitizeIntegerInput() {
			this.unarchiveValue = this.unarchiveValue.replace(/\D/g, '').replace(/^0+(?!$)/, '') || 0
		},
		changeLockedUnarchiveStatus(){
			this.lockedUnarchive = !this.lockedUnarchive
			this.debouncePersistLockedUnarchiveStatus()
		},
		debouncePersistLockedUnarchiveStatus: _debounce(function(){ this.persistLockedUnarchiveStatus() }, 600),
		persistLockedUnarchiveStatus(){
			const item_type = this.crm ? 'crm':'preproject'
			const data = {
				project_line_id: this.main_element.project_line_info.project_line_id,
				open_document_revision: !this.lockedUnarchive,
				item_type,
				item_id: this.main_element.id
			}
			updateProjectLineInfo(data)
		}
	}
}
</script>

<style scoped>
.custom-table th{
	color: white!important;
}
.custom-table th,
.custom-table td {
	font-size: 12px!important;
	text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.custom-table thead {
  background-color: #959595;
}
.custom-table tr.loading {
  background-image: linear-gradient(to right, transparent 50%, rgba(0, 0, 0, .05) 50%);
  background-size: 200% 100%;
  animation: loading 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.custom-table tr.loading td {
  opacity: .45;
  pointer-events: none;
}

@keyframes loading {
  0% {
    background-position: 0;
  }
  50% {
    background-position: -30%;
  }
  80% {
    background-position: -100%;
  }
  100% {
    background-position: -200%;
  }
}
</style>
